/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NameDto } from '../../models/name-dto';

export interface ReportControllerFindAllDropdown$Params {
}

export function reportControllerFindAllDropdown(http: HttpClient, rootUrl: string, params?: ReportControllerFindAllDropdown$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<NameDto>>> {
  const rb = new RequestBuilder(rootUrl, reportControllerFindAllDropdown.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<NameDto>>;
    })
  );
}

reportControllerFindAllDropdown.PATH = '/api/report/dropdown';
